import { Component, OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  NavController,
  ViewController,
  LoadingController,
  AlertController,
  PopoverController,
  NavParams
} from 'ionic-angular';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Md5 } from 'ts-md5/dist/md5';

import { IPayment } from './../../interfaces/payment';
import { IJob } from './../../interfaces/jobs';

@Component({
  selector: 'payment',
  templateUrl: 'payment.html'
})
export class PaymentComponent implements OnInit, OnDestroy {
  job: IJob;
  paymentData: IPayment;
  paymentUrl;

  constructor(
    public navCtrl: NavController,
    public viewCtrl: ViewController,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    public popoverCtrl: PopoverController,
    public navParams: NavParams,
    private sanitizer: DomSanitizer,
    private http: HttpClient,
  ) {
    this.paymentData = this.navParams.data.paymentData;
    this.job = this.navParams.data.job;
    console.log('--- paymentData ---');
    console.log(this.paymentData);
    console.log(this.paymentData.toString());

    let baseUrl = `https://www.payfast.co.za/eng/process?cmd=_paynow&amp;`;
    let url = `receiver=${this.paymentData.merchant_id}&amp;item_name=${this.paymentData.item_name.replace(' ', '+')}&amp;item_description=JBX+job+-+${this.job.id}&amp;amount=10.00`;
    //let encodedUrl = encodeURIComponent(url).replace(/%20/g,'+');
    

    // this.http.get(baseUrl + url).subscribe(response => {
    //   console.log(response);
    // });

    this.paymentUrl = this.sanitizer.bypassSecurityTrustResourceUrl(baseUrl + url);
    console.log('--- payment url ---');
    console.log(this.paymentUrl);

    let payment = '';   
    Object.keys(this.paymentData).forEach(key => {
      console.log(key);
      console.log(this.paymentData[key]);
      payment += `${key}=${this.paymentData[key].replace(/ /g,'+').replace(/@/g,'%40')}&`;
    });

    payment = payment.slice(0, -1);
    console.log(payment);
    let signature = Md5.hashStr(payment);
    console.log(signature);
    this.paymentData.signature = signature.toString();

    this.paymentUrl = this.sanitizer.bypassSecurityTrustResourceUrl('http://localhost:5000/jbx-app/us-central1/bigben?cmd=_paynow&' + payment + '&signature=' + this.paymentData.signature);
    console.log('--- payment url ---');
    console.log(this.paymentUrl);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'text/html'
        //'Content-Type': 'application/x-www-form-urlencoded'
      })
    };
    console.log(httpOptions);
    this.http
     .post('http://localhost:5000/jbx-app/us-central1/bigben', this.paymentData, httpOptions)
     .subscribe(response => {
       console.log(response);
     });

    // window.open(`https://sandbox.payfast.co.za/eng/process?cmd=_paynow&${payment}&signature=${this.paymentData.signature}`, "_system");
    // window.open(`https://www.payfast.co.za/eng/process?cmd=_paynow&amp;receiver=11431750&amp;item_name=jobox+-+123&amp;item_description=test+job&amp;amount=1.00`, '_system');
  }

  ngOnInit() {}

  ngOnDestroy() {}

  close() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/shared/payment/payment.ts